import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AlertContextType {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  showAlert: (
    message: string,
    type: 'success' | 'error' | 'info' | 'warning'
  ) => void;
  clearAlert: () => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState('');
  const [type, setType] = useState<'success' | 'error' | 'info' | 'warning'>(
    'info'
  );

  const showAlert = (
    message: string,
    type: 'success' | 'error' | 'info' | 'warning'
  ) => {
    setMessage(message);
    setType(type);
  };

  const clearAlert = () => {
    setMessage('');
    setType('info');
  };

  return (
    <AlertContext.Provider value={{ message, type, showAlert, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
